import { IQuestionModel } from '@care-portals/api-interfaces';

const caProvinces = [
  { code: 'ON', province: 'Ontario' },
  { code: 'QC', province: 'Quebec' },
  { code: 'AB', province: 'Alberta' },
  { code: 'BC', province: 'British Columbia' },
  { code: 'MB', province: 'Manitoba' },
  { code: 'NL', province: 'Newfoundland and Labrador' },
  // { code: 'PE', province: 'Prince Edward Island' },
  { code: 'NS', province: 'Nova Scotia' },
  { code: 'NB', province: 'New Brunswick' },
  { code: 'SK', province: 'Saskatchewan' }
  // { code: 'YT', province: 'Yukon Territory' },
  // { code: 'NT', province: 'Northwest Territories' },
  // { code: 'NU', province: 'Nunavut' }
];

const questionsModels: IQuestionModel[] = [
  /**
   * Health Card Form
   */
  {
    label: 'Please choose your province.',
    field: 'hcProvince',
    type: 'info',
    answer: {
      type: 'dropdown',
      name: 'province',
      placeholder: 'Please select',
      options: caProvinces.map(item => ({
        key: item.code,
        value: item.province
      }))
    }
  },
  {
    label: 'Please input your health card.',
    field: 'hcCardInfo',
    type: 'info',
    answer: {
      type: 'branch',
      items: [
        {
          condition: { key: 'hcProvince.province', operator: 'eq', value: 'ON' },
          answer: {
            type: 'healthCard',
            hcType: 'Ontario'
          }
        },
        {
          condition: {
            key: 'hcProvince.province',
            operator: 'ne',
            value: 'ON'
          },
          answer: {
            type: 'healthCard',
            hcType: 'Non-Ontario'
          }
        }
      ]
    }
  }
];

export default questionsModels;
